import React, { useMemo, useState } from 'react';
import { products, categories } from '../data/products';
import type { Product, CategoryFilter } from '../data/products';
import { ProductCard } from './ProductCard';
function shuffleArray<T>(array: T[]): T[] {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}
interface ProductsSectionProps {
  onAddToCart: (product: Product) => void;
}
export function ProductsSection({
  onAddToCart
}: ProductsSectionProps) {
  const [activeCategory, setActiveCategory] = useState<CategoryFilter>('todos');
  const shuffledProducts = useMemo(() => {
    const pinnedIds = [39, 40, 41, 42, 43, 44, 45, 46, 121, 120, 119];
    const pinned = products.filter(p => pinnedIds.includes(p.id));
    const remaining = products.filter(p => !pinnedIds.includes(p.id));
    const bolsos = shuffleArray(remaining.filter(p => p.category === 'bolsos'));
    const rest = shuffleArray(remaining.filter(p => p.category !== 'bolsos'));
    const firstBolsos = bolsos.slice(0, 4);
    const remainingBolsos = bolsos.slice(4);
    const mixed = shuffleArray([...remainingBolsos, ...rest]);
    return [...pinned, ...firstBolsos, ...mixed];
  }, []);
  const filteredProducts = activeCategory === 'todos' ? shuffledProducts : products.filter(p => p.category === activeCategory);
  return <section id="coleccion" data-id="element-118">
      {/* Section Title */}
      <div className="px-5 pb-[30px] pt-[60px] text-center" data-id="element-119">
        <h2 className="text-[28px] font-bold uppercase tracking-[6px]" data-id="element-120">
          Colección
        </h2>
        <div className="mx-auto my-[15px] h-[2px] w-10 bg-[#1a1a1a]" data-id="element-121" />
        <p className="text-[13px] tracking-[2px] text-[#888]" data-id="element-122">
          Tus marcas favoritas de USA, originales y disponibles ahora
        </p>
      </div>

      {/* Category Filters */}
      <div className="flex flex-wrap justify-center gap-[15px] px-5 pb-10 md:px-10" data-id="element-123">
        {categories.map(cat => <button key={cat.key} onClick={() => setActiveCategory(cat.key)} className={`px-7 py-2.5 text-[11px] uppercase tracking-[3px] transition-all duration-300 ${activeCategory === cat.key ? 'border border-[#1a1a1a] bg-[#1a1a1a] text-white' : 'border border-[#1a1a1a] bg-transparent text-[#1a1a1a] hover:bg-[#1a1a1a] hover:text-white'}`} data-id="element-124">
            {cat.label}
          </button>)}
      </div>

      {/* Products Grid */}
      <div className="px-5 pb-[60px] md:px-10 md:pb-20" data-id="element-125">
        <div className="mx-auto grid max-w-[1400px] grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4" data-id="element-126">
          {filteredProducts.map(product => <ProductCard key={product.id} product={product} onAddToCart={onAddToCart} data-id="element-127" />)}
        </div>
      </div>
    </section>;
}